// ─── Shared UI Text ───────────────────────────────────────────────────────────
// Page-specific titles, SBI labels, and profile labels live in each page file.

export const TEXT = {
  SKILLS_DETECTED_PREFIX: "Skills Detected = ",

  FOOTNOTE_IMPORTANCE: "*Importance of Skill = Importance of task for the role X Importance of skills for the task",
  FOOTNOTE_SKILLS_REQUIRED: "#Proficiency Gap = Skills needed for role - Skills possessed by employee/s",
  FOOTNOTE_SBI: "^SkillsBridge Readiness Index = Skills possessed / Skills required",

  BTN_VIEW_ALL: "View All Skills",
  BTN_SHOW_TOP5: "Show Top 5 Skills",

  PROFILE_TEXT:
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",

  NO_SUMMARY_DATA: "No group summary available.",

  COMING_SOON: "Coming Soon..",

  DROPDOWN_SKILLS_PROFICIENCY: "Skills Proficiency",
  DROPDOWN_SKILLS_MAP: "Skills Map",
};

// ─── Routes ───────────────────────────────────────────────────────────────────

export const ROUTE = {
  SKILLS_BRIDGER: "/skills-bridger",
  GROUP_SKILLS_MAP:"/skills-bridger/group-skills-map",
  EMPLOYEE_SKILLS_MAP: "/skills-bridger/employee-skills-map",
  GROUP_SKILLS_PROFICIENCY:"/Skills-bridger/group-skills-proficiency",
  EMPLOYEE_SKILLS_PROFICIENCY: "/Skills-bridger/employee-skills-proficiency",
};

// ─── Shared Skills Data (dummy — replaced by API data in production) ──────────

export const ALL_SKILLS = [
  { label: "Technical Proficiency",requiredProficiency: 10, currentProficiency: 4, importance: 3  },
  { label: "Communication",requiredProficiency: 10, currentProficiency: 4, importance: 3  },
  { label: "Financial Management", requiredProficiency: 6, currentProficiency: 10, importance: 6  },
  { label: "Analytical & Problem-solving", requiredProficiency: 10, currentProficiency: 7, importance: 12 },
  { label: "Leadership & Team Management", requiredProficiency: 8, currentProficiency: 2, importance: 24 },
  { label: "Project Management", requiredProficiency: 9, currentProficiency: 5, importance: 20 },
  { label: "Creativity", requiredProficiency: 6,  currentProficiency: 4, importance: 9  },
  { label: "Time Management",  requiredProficiency: 10, currentProficiency: 3, importance: 15 },
  { label: "Strategic Thinking", requiredProficiency: 7, currentProficiency: 7, importance: 29 }
];

export const TOP_SKILLS_COUNT = 5;
